module.exports = __webpack_public_path__ + "17279211d42d3c798e857c12efbd469e.svg";